/**
 * Nigerian states and their major cities for the location selector.
 * Includes all 36 states and the Federal Capital Territory (Abuja).
 */

export const STATES = [
  'Abia',
  'Adamawa',
  'Akwa Ibom',
  'Anambra',
  'Bauchi',
  'Bayelsa',
  'Benue',
  'Borno',
  'Cross River',
  'Delta',
  'Ebonyi',
  'Edo',
  'Ekiti',
  'Enugu',
  'FCT (Abuja)',
  'Gombe',
  'Imo',
  'Jigawa',
  'Kaduna',
  'Kano',
  'Katsina',
  'Kebbi',
  'Kogi',
  'Kwara',
  'Lagos',
  'Nasarawa',
  'Niger',
  'Ogun',
  'Ondo',
  'Osun',
  'Oyo',
  'Plateau',
  'Rivers',
  'Sokoto',
  'Taraba',
  'Yobe',
  'Zamfara',
];

export const CITIES_BY_STATE = {
  Abia: ['Aba', 'Umuahia', 'Ohafia', 'Arochukwu', 'Bende'],
  Adamawa: ['Yola', 'Jimeta', 'Mubi', 'Numan', 'Ganye'],
  'Akwa Ibom': ['Uyo', 'Eket', 'Ikot Ekpene', 'Oron', 'Abak'],
  Anambra: ['Awka', 'Onitsha', 'Nnewi', 'Ekwulobia', 'Ihiala'],
  Bauchi: ['Bauchi', 'Azare', 'Misau', 'Jama\'are', 'Katagum'],
  Bayelsa: ['Yenagoa', 'Brass', 'Nembe', 'Ogbia', 'Sagbama'],
  Benue: ['Makurdi', 'Gboko', 'Otukpo', 'Katsina-Ala', 'Vandeikya'],
  Borno: ['Maiduguri', 'Biu', 'Bama', 'Dikwa', 'Gwoza'],
  'Cross River': ['Calabar', 'Ikom', 'Ogoja', 'Ugep', 'Obudu'],
  Delta: ['Asaba', 'Warri', 'Sapele', 'Ughelli', 'Agbor'],
  Ebonyi: ['Abakaliki', 'Afikpo', 'Onueke', 'Edda', 'Ishiagu'],
  Edo: ['Benin City', 'Auchi', 'Ekpoma', 'Uromi', 'Irrua'],
  Ekiti: ['Ado-Ekiti', 'Ikere', 'Ijero', 'Ikole', 'Oye-Ekiti'],
  Enugu: ['Enugu', 'Nsukka', 'Agbani', 'Awgu', 'Udi'],
  'FCT (Abuja)': ['Abuja', 'Gwagwalada', 'Kuje', 'Bwari', 'Abaji'],
  Gombe: ['Gombe', 'Kumo', 'Billiri', 'Dukku', 'Deba'],
  Imo: ['Owerri', 'Orlu', 'Okigwe', 'Mbaise', 'Oguta'],
  Jigawa: ['Dutse', 'Hadejia', 'Gumel', 'Kazaure', 'Ringim'],
  Kaduna: ['Kaduna', 'Zaria', 'Kafanchan', 'Saminaka', 'Zonkwa'],
  Kano: ['Kano', 'Wudil', 'Gaya', 'Dambatta', 'Bichi'],
  Katsina: ['Katsina', 'Funtua', 'Daura', 'Malumfashi', 'Kankia'],
  Kebbi: ['Birnin Kebbi', 'Argungu', 'Yauri', 'Zuru', 'Jega'],
  Kogi: ['Lokoja', 'Okene', 'Idah', 'Kabba', 'Anyigba'],
  Kwara: ['Ilorin', 'Offa', 'Omu-Aran', 'Kaiama', 'Patigi'],
  Lagos: ['Ikeja', 'Lekki', 'Ikorodu', 'Badagry', 'Epe', 'Surulere', 'Victoria Island'],
  Nasarawa: ['Lafia', 'Keffi', 'Akwanga', 'Karu', 'Doma'],
  Niger: ['Minna', 'Bida', 'Kontagora', 'Suleja', 'Mokwa'],
  Ogun: ['Abeokuta', 'Ota', 'Ijebu Ode', 'Sagamu', 'Ilaro'],
  Ondo: ['Akure', 'Ondo Town', 'Owo', 'Okitipupa', 'Ikare'],
  Osun: ['Osogbo', 'Ile-Ife', 'Ilesa', 'Ede', 'Iwo'],
  Oyo: ['Ibadan', 'Ogbomoso', 'Oyo', 'Iseyin', 'Saki'],
  Plateau: ['Jos', 'Bukuru', 'Pankshin', 'Shendam', 'Langtang'],
  Rivers: ['Port Harcourt', 'Obio-Akpor', 'Bonny', 'Eleme', 'Ahoada', 'Okrika'],
  Sokoto: ['Sokoto', 'Tambuwal', 'Wurno', 'Gwadabawa', 'Bodinga'],
  Taraba: ['Jalingo', 'Wukari', 'Bali', 'Gembu', 'Takum'],
  Yobe: ['Damaturu', 'Potiskum', 'Gashua', 'Nguru', 'Geidam'],
  Zamfara: ['Gusau', 'Kaura Namoda', 'Talata Mafara', 'Tsafe', 'Anka'],
};

export const getCitiesForState = (state) =>
  (state && CITIES_BY_STATE[state]) || [];
